module.exports = __webpack_public_path__ + "img/gr.b416c9f6.svg";